<script setup lang="ts">
import { useGtm } from '@gtm-support/vue-gtm'

import imageAppleBlack from '@/assets/images/footer/footer-apple-black.webp'
import imageGooglePlayBlack from '@/assets/images/footer/footer-google-play-black.webp'
import imageHuaweiBlack from '@/assets/images/footer/footer-huawei-black.webp'

type Props = {
  isShowFullText?: boolean
}

const props = defineProps<Props>()

const { isDesktop } = useResponsive()

const gtm = useGtm()

const onClickLink = () => {
  if (!gtm) return

  gtm.trackEvent({
    event: 'appdown-mob',
  })
}
</script>

<template>
  <the-button
    variant="tertiary"
    href="/a/"
    target="_blank"
    title="Скачать приложение Farfor"
    @click="onClickLink"
  >
    <span data-test-id="button-text">
      <span v-if="isDesktop && !props.isShowFullText">Скачать</span>
      <span v-else>Скачать приложение</span>
    </span>

    <template #append>
      <nuxt-img
        width="16"
        height="16"
        :src="imageAppleBlack"
        alt="IOS"
        data-test-id="apple-icon"
      />
      <nuxt-img
        width="16"
        height="16"
        :src="imageGooglePlayBlack"
        alt="GooglePay"
        data-test-id="google-icon"
      />
      <nuxt-img
        width="16"
        height="16"
        :src="imageHuaweiBlack"
        alt="Huawei"
        data-test-id="huawei-icon"
      />
    </template>
  </the-button>
</template>
